export default __webpack_public_path__ + "c19e7ed639781cce04c0149ab82bb4f8.svg";